/**
 * Small platform ports — capabilities core needs but cannot implement
 * portably. Web and React Native each provide implementations.
 */
/** No-op defaults for platforms/tests that don't wire these up */
export const grantedMicPermission = {
    isGranted: async () => true,
    request: async () => true,
};
export const silentNotificationPlayer = {
    play: () => { },
};
